module.exports = __webpack_public_path__ + "img/img-8665a2.png";